<template>
  <b-list-group-item v-if="value">
    <div class="font-weight-bold text-primary">
      {{ title }}
    </div>
    <span v-if="isCurrency">
      {{ value | toCurrency }} TL
    </span>
    <span v-else>
      {{ value }}
    </span>

  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'ListItem',
  components: {
    BListGroupItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    isNumber: {
      type: Boolean,
      default: false,
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
